import React, { useMemo } from 'react'
import { useTestEnvQueryParameter } from 'hooks/useTestEnvQueryParameter'
import { Cohort } from 'root-constants'
import { useSelector } from 'react-redux'
import {
  selectCurrentVariantCohort,
  selectFacebookPixelId,
} from 'root-redux/selects/common'
import { useFacebookPixelInitialization } from 'hooks/useFacebookPixelInitialization'
import { useEventLoggerInitialization } from 'hooks/useEventLoggerInitialization'
import { useScrollToTop } from 'hooks/useScrollToTop'
import { useAbSegmentName } from 'hooks/useAbSegmentName'
import { Header } from 'components/Header'
import { TopDecorationFrame } from 'components/TopDecorationFrame'
import { useRemoveAnimatedBackground } from 'hooks/useRemoveAnimatedBackground'
import { useGAPageTracker } from 'hooks/useGAPageTracker'
import { useLocation } from 'react-router'
import { getPageIdFromPathName } from 'helpers/getPageIdFromPathName'
import { PageId } from 'page-constants'
import { useBackgroundColor } from 'hooks/useBackgroundColor'
import { RouteList } from '../../RouteList'

export const LayoutProvider: React.FC = () => {
  const cohort = useSelector(selectCurrentVariantCohort)
  const facebookPixelId = useSelector(selectFacebookPixelId)
  const { pathname } = useLocation()

  useGAPageTracker()
  useRemoveAnimatedBackground()
  useBackgroundColor()
  useFacebookPixelInitialization(facebookPixelId)
  useEventLoggerInitialization(cohort as Cohort)
  useScrollToTop()
  useTestEnvQueryParameter()
  useAbSegmentName()

  const isResultPage = useMemo(
    () => getPageIdFromPathName(pathname) === PageId.RESULT,
    [pathname],
  )

  return (
    <>
      <Header />
      {!isResultPage && <TopDecorationFrame />}
      <RouteList />
    </>
  )
}
